import { RouteConfig } from 'vue-router'

const sysopRoutes: Array<RouteConfig> = [
  {
    path: ':role/sysop_message',
    name: 'sysop_message',
    meta: { inherit: true },
    component: () => import('./SystemMessage.vue'),
  },
  {
    path: ':role/sysop_web',
    name: 'sysop_web_page',
    meta: { inherit: true },
    component: () => import('./SystemWebPage.vue'),
  },
  {
    path: ':role/sysop_rules',
    name: 'sysop_rules',
    meta: { inherit: true },
    component: () => import('./SystemConfig.vue'),
  },
  {
    path: ':role/sysop_import_stock',
    name: 'sysop_import_stock',
    meta: { inherit: true },
    component: () => import('./SystemImportStock.vue'),
  },
  {
    path: ':role/sysop_company',
    name: 'sysop_company',
    meta: { inherit: true },
    component: () => import('./SystemCompany.vue'),
  },
  {
    path: ':role/sysop_employee',
    name: 'sysop_users',
    meta: { inherit: true },
    component: () => import('./SystemUsers.vue'),
  },
  {
    path: ':role/sysop_executive',
    name: 'sysop_executive',
    meta: { inherit: true },
    component: () => import('../SystemExecutive.vue'),
  },
]

export default sysopRoutes
